// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormAddFinancingSource } from '../../forms/FormAddFinancingSource/FormAddFinancingSource';

// props
export interface DialogAddFinancingSourceProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogAddFinancingSource = ({
	isOpen,
	onClose,
	onSuccess,
}: DialogAddFinancingSourceProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('addFinancingSource'),
					form: 'form-add-loan',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			onClose={onClose}
			title={{
				children: t('addFinancingSource'),
				variant: 'h3',
			}}>
			<FormAddFinancingSource onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
